<template>
  <svg
    width="20"
    height="13"
    viewBox="0 0 20 13"
  >
    <path d="M10 4.00462C12.2091 4.00462 14 5.79549 14 8.00462C14 10.2138 12.2091 12.0046 10 12.0046C7.79086 12.0046 6 10.2138 6 8.00462C6 5.79549 7.79086 4.00462 10 4.00462ZM10 5.50462C8.61928 5.50462 7.5 6.62391 7.5 8.00462C7.5 9.38534 8.61928 10.5046 10 10.5046C11.3807 10.5046 12.5 9.38534 12.5 8.00462C12.5 6.62391 11.3807 5.50462 10 5.50462ZM10 0.5C14.6135 0.5 18.5961 3.65001 19.7011 8.06439C19.8017 8.4662 19.5575 8.87348 19.1557 8.97406C18.7539 9.07465 18.3466 8.83045 18.246 8.42863C17.3071 4.67796 13.9214 2 10 2C6.07693 2 2.69009 4.68026 1.75285 8.43315C1.65249 8.83502 1.24535 9.07944 0.843479 8.97908C0.441608 8.87872 0.197187 8.47158 0.29755 8.06971C1.40064 3.65272 5.38448 0.5 10 0.5Z" />
  </svg>
</template>
